export function chunkArray(originArr, len) {
  const chunkArr = [];
  if (originArr.length <= len) {
    chunkArr.push(originArr);
  } else {
    let index = 0;
    for (let i = 0; i < originArr.length; i += 1) {
      if (i % len === 0) {
        index = Math.floor(i / len);
        chunkArr[index] = [];
      }
      chunkArr[index].push(originArr[i]);
    }
  }
  return chunkArr;
}
